/* eslint-disable react-hooks/exhaustive-deps */
import { act, useEffect, useState } from "react";
import { useConfirmation } from "src/base/ConfirmationDialog/ConfirmationService";
import { Button, DataGrid, Dialog, Grid, NumberField } from "src/components";
import { BarcodeInfo, SignalRService } from "src/services/Printer/SignalRService";
import { useGetVwKullaniciEkranraporQuery, useLazyExportPrintPdfQuery, useLazySabitReportFileWriteQuery, useGetRaporSorguSablonQuery } from "src/services/Printer/PrinterApi";
import { useAppDispatch, useAppSelector } from "src/store";
import KararDestekSlice from "src/store/Slices/KararDestekSlices";
import { helper } from "src/utils/helper";
import ButtonPrintViewer from "./ButtonPrintViewer";
import DialogTitle from "src/components/DialogTitle";
import DialogActions from "src/components/DialogActions";
import DialogContent from "src/components/DialogContent";
import VwKullaniciEkranraporDTO from "src/models/Print/VwKullaniciEkranraporDTO";
import { useCrateKullaniciVarsayilanMutation, useDeleteKullaniciVarsayilanMutation, useGetKullaniciVarsayilanListQuery } from "src/services/Base/GnlKullaniciVarsayilanApi";
import { GridCallbackDetails, GridCellParams, GridColumnVisibilityModel, GridTreeNode, MuiEvent } from "@mui/x-data-grid-premium";
import GnlKullanicivarsayilanDTO from "src/models/Genel/GnlKullanicivarsayilanDTO";
import SnackbarUtils from "src/utils/SnackbarUtils";
import { translate } from 'src/i18n/tHelper';

const translatePath = "pages";

let terminal: SignalRService = new SignalRService();
const ButtonPrintDialog = (): JSX.Element => {
    const state = useAppSelector(s => s.kararDestek);
    const dispatch = useAppDispatch();
    const { userInfo } = useAppSelector(s => s.userLogin);
    const query = useGetVwKullaniciEkranraporQuery({ ekranKodu: state.sabitRow.ekranKodu, modulId: state.sabitRow.modulId, kullaniciId: userInfo.id }, { skip: !state.sabitRow.ekranKodu, refetchOnMountOrArgChange: true });
    const sablonQuery = useGetRaporSorguSablonQuery({
        pkRaporsorgu: state?.kullaniciEkranraporDTO?.pkRaporsorgu,
        parameters: state.sabitRow.params.parameters
    }, { skip: state?.kullaniciEkranraporDTO?.pkRaporsorgu && state.sabitRow.params.parameters?.length > 0 ? false : true, refetchOnMountOrArgChange: true });
    const [selectionModel, setSelectionModel] = useState<Array<number>>([]);
    const [varsayilanAtaId, setVarsayilanAtaId] = useState<number>(0);

    const kullaniciVarsayilanQuery = useGetKullaniciVarsayilanListQuery(userInfo.id);
    const [kullaniciVarsayilanEkle, kullaniciVarsayilanEkleState] = useCrateKullaniciVarsayilanMutation();
    const [kullaniciVarsayilanGuncelle, kullaniciVarsayilanGuncelleState] = useDeleteKullaniciVarsayilanMutation();
    const kayit = kullaniciVarsayilanQuery?.data?.find((m) => m?.ekranAd === `BTN_PRINT_${state.kullaniciEkranraporDTO?.ekrankodu}` && m?.kontrolad === "BTN_PRINT_VARSAYILAN");

    useEffect(() => {
        if (!kayit)
            if (!query.isFetching && query.data?.length > 0) {
                dispatch(KararDestekSlice.actions.setState({
                    ...state,
                    kullaniciEkranraporDTO: query.data[0]
                }));
                setSelectionModel([query.data[0].pkRaporsorgu]);
            }
    }, [query.isFetching]);

    useEffect(() => {
        if (!query.isFetching && query.data?.length > 0) {
            let selectedRapor = query.data[0];

            if (kayit?.id > 0) {
                const varsayilan = query.data.find(m => m.pkRaporsorgu === helper.objectToNumber(kayit.deger));
                if (varsayilan) {
                    selectedRapor = varsayilan;
                }
            }

            dispatch(KararDestekSlice.actions.setState({
                ...state,
                kullaniciEkranraporDTO: selectedRapor
            }));
            setSelectionModel([selectedRapor.pkRaporsorgu]);
        }
    }, [query.isFetching, query.data, kayit?.id]);

    const [sabitReportQuery, sabitReportState] = useLazySabitReportFileWriteQuery();
    const confirm = useConfirmation();
    const [printLoading, setPrintLoading] = useState(false);
    const [exportPdfQuery, exportPdfState] = useLazyExportPrintPdfQuery();

    const handleClick = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, tip: number) => {
        if (!state.kullaniciEkranraporDTO.pkRaporsorgu)
            return;
        if (tip === 1) {
            sabitReportQuery({
                parameters: state.sabitRow.params.parameters,
                pkRaporsorgu: state.kullaniciEkranraporDTO.pkRaporsorgu
            })
                .unwrap()
                .then(res => {
                    dispatch(KararDestekSlice.actions.setState({
                        ...state,
                        open: true,
                        reportGuid: res,
                        parameters: state.sabitRow.params.parameters,
                        raporSorgu: {
                            raporAdi: state.kullaniciEkranraporDTO.adi,
                            raporsorguId: state.kullaniciEkranraporDTO.pkRaporsorgu
                        },
                        print: true
                    }))
                })
                .catch(e => e)
        } else if (tip === 2) {
            if (localStorage.getItem("barcodePrinter")?.toString() === "undefined" || localStorage.getItem("laserPrinter")?.toString() === "undefined") {
                confirm({
                    description: translate(
                        translatePath,
                        'Yazıcı ayarlarınızda eksiklik mevcut. Lütfen yazıcı ayarlarınızı yapınız.'
                    )
                })
                return;
            }
            var printer = "";
            if (state.kullaniciEkranraporDTO.printerType === 1) {
                printer = localStorage.getItem("laserPrinter")?.toString()
            } else {
                printer = localStorage.getItem("barcodePrinter")?.toString()
            }
            if (state.sabitRow?.cokluYazdir && state.sabitRow?.miktar > 1) {
                for (let i = 0; i < state.sabitRow.miktar; i++) {
                    await new Promise(async (resolve, reject) => {
                        await printSignalR(printer).then(resolve).catch(error => resolve(error));
                    });
                }
            } else {
                await new Promise(async (resolve, reject) => {
                    await printSignalR(printer).then(resolve).catch(error => resolve(error));
                });
            }
        }
    };
    const printSignalR = async (printer: string) => {
        setPrintLoading(true);
        terminal = new SignalRService();
        try {
            await terminal.connect();
            if (state.sabitRow.ekranKodu == "alisbarkod" || state.sabitRow.ekranKodu == "rezervbarkod" || helper.UpperCaseAsc(state.sabitRow.ekranKodu) === "LABORATUVARBARKOD" || helper.UpperCaseAsc(state.sabitRow.ekranKodu) === "NUMUNEKABULBARKOD") {
                await terminal.barcodePrint(
                    {
                        XmlSablon: sablonQuery.data[0],
                        SorguSablon: sablonQuery.data[1],
                        PrinterName: printer
                    } as BarcodeInfo
                ).then(() => {
                    setPrintLoading(false);
                    terminal.disConnect();
                    if (state.sabitRow.onPrintComplete) {
                        state.sabitRow.onPrintComplete(true);
                    }
                }).catch(e => {
                    if (state.sabitRow.onPrintComplete) {
                        state.sabitRow.onPrintComplete(true);
                    }
                    return e;
                });
            } else {
                await exportPdfQuery({
                    pkRaporsorgu: state.kullaniciEkranraporDTO.pkRaporsorgu,
                    parameters: state.sabitRow.params.parameters
                }).unwrap().then((r) => {
                    const base64data = helper.blobToBase64(r);
                    base64data.then((res) => {
                        terminal.reportPrint({ XmlSablon: res, PrinterName: printer } as BarcodeInfo).then(() => {
                            setPrintLoading(false);
                        });
                        if (state.sabitRow.onPrintComplete) {
                            state.sabitRow.onPrintComplete(true);
                        }
                    }).catch(e => e)
                }).catch(e => e);
            }
            setPrintLoading(false);
        } catch (error) {
            if (state.sabitRow.onPrintComplete) {
                state.sabitRow.onPrintComplete(false);
            }
            setPrintLoading(false);
            await terminal.disConnect();
            confirm({
                title: translate(translatePath, "Uyarı"),
                description: translate(translatePath, 'Terminal ile bağlantı kurulamadı!'),
                variant: "info"
            });
        }
    };

    const varsayilanAyarla = async (id: number) => {
        if (!id)
            return;
        if (!kullaniciVarsayilanQuery.isFetching && !kullaniciVarsayilanEkleState.isLoading && !kullaniciVarsayilanGuncelleState.isLoading) {
            if (kayit?.id > 0) {
                await kullaniciVarsayilanGuncelle(kayit?.id).unwrap().then(() => { }).catch(e => e);
                setVarsayilanAtaId(0);
            }
            else {
                let veri: GnlKullanicivarsayilanDTO = {
                    ...new GnlKullanicivarsayilanDTO(),
                    ekranAd: `BTN_PRINT_${state.kullaniciEkranraporDTO?.ekrankodu}`,
                    kontrolad: "BTN_PRINT_VARSAYILAN",
                    deger: helper.objectToString(id),
                    fkGnlKullanici: userInfo.id,
                };
                await kullaniciVarsayilanEkle(veri).unwrap().then(() => { }).catch(e => e);
                setVarsayilanAtaId(0);
            }
        }
    };

    useEffect(() => {
        if (varsayilanAtaId > 0) {
            (async () => {
                await varsayilanAyarla(varsayilanAtaId);
            })();
        }
    }, [varsayilanAtaId]);

    const onCellClick = (params: GridCellParams<any, unknown, unknown, GridTreeNode>, event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>, details: GridCallbackDetails): void => {
        if (params.field === "action5") {
            setVarsayilanAtaId(params.row?.pkRaporsorgu);
        }
    };
    const [visibilityColumn, setVisibilityColumn] = useState<GridColumnVisibilityModel>({
        action4: state.sabitRow?.cokluYazdir ? true : false,
        adi: true,
        action5: true,
    });
    return (
        <>
            <Dialog fullWidth open={state.openDialog} maxWidth={"md"}>
                <DialogTitle>{translate("common", "Yazdır")}</DialogTitle>
                <DialogContent>
                    <DataGrid
                        columns={[
                            {
                                field: "adi",
                                flex: 1,
                                minWidth: 200,
                                headerName: translate("common", "Rapor Adı"),
                            },
                            {
                                field: "action4",
                                headerName: translate("common", "Miktar"),
                                width: 120,
                                type: "number",
                                renderCell: (params) => {
                                    return (
                                        <NumberField
                                            borderNone={true}
                                            name="miktar"
                                            value={state.sabitRow?.miktar}
                                            onChange={(e, v) => {
                                                dispatch(KararDestekSlice.actions.setState({
                                                    ...state,
                                                    sabitRow: {
                                                        ...state.sabitRow,
                                                        miktar: e.target.value
                                                    },
                                                }));
                                            }}
                                        />
                                    );
                                },
                            },
                            {
                                field: "action5",
                                headerName: translate("common", "Varsayılan"),
                                width: 80,
                                type: "boolean",
                                valueGetter: (params) => {
                                    return (helper.objectToNumber(kayit?.deger) === params.row?.pkRaporsorgu) ? true : false;
                                }
                            }
                        ]}
                        rows={query.data || []}
                        loading={query.isFetching || sabitReportState.isLoading || printLoading || sablonQuery.isFetching || exportPdfState.isFetching}
                        getRowId={(e) => e.pkRaporsorgu}
                        hideFooter
                        disableMultipleRowSelection
                        enableQuickFilter
                        hiddenExport
                        editMode="cell"
                        columnVisibilityModel={visibilityColumn}
                        onColumnVisibilityModelChange={(m, d) => {
                            setVisibilityColumn(m);
                        }}
                        initialState={{
                            columns: {
                                columnVisibilityModel: visibilityColumn
                            }
                        }}
                        rowSelectionModel={selectionModel}
                        onRowSelectionModelChange={(e, d) => {
                            setSelectionModel(e as any)
                        }}
                        columnHeaderHeight={0}
                        onRowClick={(params) => {
                            dispatch(KararDestekSlice.actions.setState({
                                ...state,
                                kullaniciEkranraporDTO: params.row
                            }));
                        }}
                        onCellClick={onCellClick}
                        hiddenColumnsButton
                        hiddenFilters
                        hideFooterSelectedRowCount
                        sx={{
                            height: 300
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="right">
                        <Grid item md={4}>
                            <Button
                                customType="print"
                                loading={query.isFetching || sabitReportState.isLoading || printLoading || sablonQuery.isFetching || exportPdfState.isFetching}
                                onClick={(e) => { handleClick(e, 2); }}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Button
                                customType="visibility"
                                loading={query.isFetching || sabitReportState.isLoading || printLoading || sablonQuery.isFetching || exportPdfState.isFetching}
                                onClick={(e) => { handleClick(e, 1); }}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Button
                                customType="close"
                                onClick={(e) => {
                                    dispatch(KararDestekSlice.actions.setState({
                                        ...state,
                                        openDialog: false,
                                        kullaniciEkranraporDTO: new VwKullaniciEkranraporDTO(),
                                        sabitRow: { params: { errorMessage: "", parameters: [] }, modulId: null, ekranKodu: "" },
                                    }));
                                    if (state.sabitRow.onViewerClose)
                                        state.sabitRow.onViewerClose();
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            {state.open && <ButtonPrintViewer />}
        </>
    )
}
export default ButtonPrintDialog;